import {
  AccessCardDetailsProps,
  AccessCardResponse,
} from '../../../../types/EmployeeDirectory/AccessCardDetails/accessCardDetailsTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../utils/apiUtils'
import { accessCardDetailsApiConfig, AllowedHttpMethods } from '../../apiList'

const getAllAccessCardDetails = async (
  props: AccessCardDetailsProps,
): Promise<AccessCardResponse> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: accessCardDetailsApiConfig.getAccessCardsList,
    method: AllowedHttpMethods.get,
    params: {
      startIndex: props.startIndex ?? 20,
      endIndex: props.endIndex ?? 0,
      country: props.country,
      status: props.status,
      search: props.searchStr,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}
const exportAccessCardsList = async (
  props: AccessCardDetailsProps,
): Promise<Blob | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: accessCardDetailsApiConfig.exportAccessCardsList,
    method: AllowedHttpMethods.get,
    params: {
      country: props.country,
      status: props.status,
      search: props.searchStr,
    },
    responseType: 'blob',
  })

  const response = await useAxios(requestConfig)
  return response.data
}

export const AccessCardDetailsApi = {
  getAllAccessCardDetails,
  exportAccessCardsList,
}
